export default __webpack_public_path__ + "static/media/Calendar.945f8533.svg";